import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export class LanguageService {

	public static languageGetByFilter() {
		return Http.axios().get('/api/Language/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static languageGetDetail(languageCode: string) {
		return Http.axios().get('/api/Language/details/' + languageCode, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static languageSave(input) {
		return Http.axios().post('/api/Language/add', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => { return res; })
			.catch((e: any) => { return e.response; });
	}

	public static languageUpdate(input) {
		return Http.axios().put('/api/Language/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {return res; })
			.catch((e: any) => { return e.response; });
	}

	public static languageDelete(languageCode: string) {
		return Http.axios().delete('/api/Language/delete/' + languageCode, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}